import { ITranslations } from 'types/common';
import { NoDataTransFields } from './types';
import en from 'translations/en/noData.json';
import pl from 'translations/pl/noData.json';
import sl from 'translations/sl/noData.json';

export const noDataTranslations: ITranslations<NoDataTransFields> = {
  name: 'noData',
  en,
  pl,
  sl,
};
